import defaultSettings from "@/settings";

const title = defaultSettings.title || "好用、可协作的农场管理工具（农场ERP）";

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}
